// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__gR9sN","amount":"Amount_amount__1WAkt","tip":"Amount_tip__2i3gz","tipHeader":"Amount_tipHeader__3xG-S","tipsWrap":"Amount_tipsWrap__1wC5x"};